import { CalculationType } from '@/__generated__/graphql';

export const BREASTING = 'breasting';

export const RUBBER_FENDER = 'rubberFender';

export const MOORING = 'mooring';

export const LOADING = 'loading';

export const FENDER_PANEL_FACING = 'fenderPanelFacing';

export const FENDER_PANEL_FRAMING = 'fenderPanelFraming';

export const BASE = 'base';

export const UHMW_FACING = 'UHMW-PE Facing';

export const TIMBER_FACING = 'Timber Facing';

export const NO_EQUATIONS_EXIST = ['fenderPanelFacing'];

export const FENDER_COMPONENTS = [
  'rubber fender',
  'rubber fenders',
  'fender panel facing',
  'fender facing',
  'fender panel framing',
  'fender panel framings',
  'fender panel chain',
  'fender panel chains',
  'fender anchor',
  'fender anchors',
  'fender framing',
  'fender weight chain',
  'fender weight chains',
  'fender shear chain',
  'fender shear chains',
];

export const STEEL = 'steel';

export const REINFORCED_CONCRETE = 'reinforced_concrete';

export const CONCRETE = 'concrete';

export const DAMAGE_CLASS_TO_BASE_POF_MAP = [
  { name: 'DC5', value: 0.3 },
  { name: 'DC4', value: 0.03 },
  { name: 'DC3', value: 0.003 },
  { name: 'DC2', value: 0.0003 },
  { name: 'DC1', value: 0.000_03 },
  { name: 'DC0', value: 0.000_03 },
];

export const CALCULATED_TO_ACTUAL_POF_MAP = [
  { calculatedValue: 0.3, actualValue: 'A' },
  { calculatedValue: 0.03, actualValue: 'B' },
  { calculatedValue: 0.003, actualValue: 'C' },
  { calculatedValue: 0.0003, actualValue: 'D' },
  { calculatedValue: 0.00003, actualValue: 'E' },
];

export const EQUATIONS: Record<CalculationType, string> = {
  [CalculationType.Breasting]: `E × (50/1) × N × R × D × F × C`,
  [CalculationType.Mooring]: `E × (50/1) × (N × H × F × W) × D × O × C`,
  [CalculationType.FenderPanelFraming]: `E × (50/1) × N × D × F`,
  [CalculationType.Base]: `E × P1 × P2`,
  [CalculationType.Loading]: `E × P1 × P2`,
  [CalculationType.RubberFender]: `E × N × (Age factor Multiplier or Hardness factor)`,
  [CalculationType.FenderPanelFacing]: ``,
};

export const YEARS_MULTIPLIER_MAP = {
  'Years  <15': 1,
  'Years 15-25': 10,
  'Years 25-30': 100,
  'Years >30': 1000,
};

export const LONGITUDINAL_CRACKING_MAP = {
  '0 to 10% Depth': 1,
  '10 to 20% Depth': 10,
  '20 to 30% Depth': 100,
  '>30% Depth': 1000,
};

export const CIRCUMFERENTIAL_CRACKING_MAP = {
  '0 to 10% Diameter': 1,
  '10 to 20% Diameter': 10,
  '20 to 30% Diameter': 100,
  '>30% Diameter': 1000,
};

export const SAGGING_FENDER_MAP = {
  '0 to 10% Depth': 1,
  '10 to 20% Depth': 10,
  '20 to 30% Depth': 100,
  '>30% Depth': 1000,
};

export const COMPRESSION_SET_FENDER_MAP = {
  '0 to 5% Depth': 1,
  '5 to 10% Depth': 10,
  '10 to 15% Depth': 100,
  '>15% Depth': 1000,
};

export const RUBBER_HARDNESS_MAP = {
  'Hardness Increase 0 to 10% Increase over Original': 1,
  'Hardness Increase 10 to 20% Increase over Original': 10,
  'Hardness Increase 20 to 30% Increase over Original': 100,
  'Hardness Increase more than 30% Increase over Original': 1000,
};

export const calculationKeys = [
  { key: 'risk_base_pof_value', name: 'Input POF Value', isHidden: false, isInput: true },
  { key: 'risk_dc_base_pof_value', name: 'Base POF Value', isHidden: false, isInput: true },
  { key: 'risk_actual_base_pof', name: 'Base POF', isHidden: true, isInput: false },
  { key: 'risk_calculated_pof', name: 'POF Calculated', isHidden: false, isInput: false },
  {
    key: 'risk_ships_accepted_annually_at_berth',
    name: 'Ships Accepted Annually at Berth',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_safety_calculated_value_pof',
    name: 'Safety (POF)',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_environment_calculated_value_pof',
    name: 'Environment (POF)',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_public_impact_calculated_value_pof',
    name: 'Public Impact (POF)',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_direct_cost_calculated_value_pof',
    name: 'Direct Cost (POF)',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_business_loss_calculated_value_pof',
    name: 'Business Loss (POF)',
    isHidden: false,
    isInput: false,
  },
  { key: 'risk_safety_cof', name: 'Safety (COF)', isHidden: false, isInput: true },
  { key: 'risk_environment_cof', name: 'Environment (COF)', isHidden: false, isInput: true },
  { key: 'risk_public_impact_cof', name: 'Public Impact (COF)', isHidden: false, isInput: true },
  { key: 'risk_direct_cost_cof', name: 'Direct Cost (COF)', isHidden: false, isInput: true },
  { key: 'risk_business_loss_cof', name: 'Business Loss (COF)', isHidden: false, isInput: true },
  { key: 'risk_transition_period', name: 'Transition Period', isHidden: false, isInput: true },
  { key: 'risk_safety_actual_value_pof', name: 'Safety POF', isHidden: true, isInput: false },
  {
    key: 'risk_public_impact_actual_value_pof',
    name: 'Public Impact POF',
    isHidden: true,
    isInput: false,
  },
  { key: 'risk_direct_cost_actual_value_pof', name: 'Direct Cost', isHidden: true, isInput: false },
  {
    key: 'risk_business_loss_actual_value_pof',
    name: 'Business Loss POF',
    isHidden: true,
    isInput: false,
  },
  { key: 'risk_coating_system', name: 'Coating System', isHidden: false, isInput: true },
  {
    key: 'risk_corrosivity_category',
    name: 'Corrosivity Category',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_structure_age', name: 'Built Year', isHidden: false, isInput: true },
  { key: 'risk_inspection_year', name: 'Inspection Year', isHidden: false, isInput: true },
  { key: 'risk_unmitigated_safety', name: '', isHidden: true, isInput: false },
  { key: 'risk_unmitigated_environment', name: '', isHidden: true, isInput: false },
  { key: 'risk_unmitigated_public_impact', name: '', isHidden: true, isInput: false },
  { key: 'risk_unmitigated_direct_cost', name: '', isHidden: true, isInput: false },
  {
    key: 'risk_unmitigated_business_loss',
    name: 'Governing Financials',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_safety_calculated_value',
    name: 'Safety',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_environment_calculated_value',
    name: 'Environment',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_public_impact_calculated_value',
    name: 'Public Impact',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_direct_cost_calculated_value',
    name: 'Direct Cost',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_business_loss_calculated_value',
    name: 'Business Loss',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_she_calculated_value',
    name: 'Governing SHE ISO Risk',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_she_actual_value',
    name: 'Governing SHE',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_hours_vessel_at_berth',
    name: 'Hours vessel at berth (H)',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_selected_method', name: 'Selected Method', isHidden: false, isInput: true },
  {
    key: 'risk_time_vessel_at_draft_condition_governing_limits',
    name: 'Time vessel at draft condition governing limits (F)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_hours_per_year',
    name: 'Hours per year, disconnect Hose/Arm Wind Limit reached (W)',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_design_factor', name: 'Design factor (D)', isHidden: false, isInput: true },
  { key: 'risk_redundancy_factor', name: 'Redundancy factor (R)', isHidden: false, isInput: true },
  { key: 'risk_experience_factor', name: 'Experience factor (F)', isHidden: false, isInput: true },
  {
    key: 'risk_potential_operator',
    name: "Potential operator won't intervene / take special precautions (O)",
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_thickness', name: 'Thickness', isHidden: false, isInput: true },
  { key: 'risk_cathodic_protection', name: 'Cathodic Protection', isHidden: false, isInput: true },
  {
    key: 'risk_manual_transition',
    name: 'Manual Transition Calculation',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_safety_value_pof_p1', name: 'Safety P1 (POF)', isHidden: false, isInput: true },
  { key: 'risk_safety_value_pof_p2', name: 'Safety P2 (POF)', isHidden: false, isInput: true },
  {
    key: 'risk_environment_value_pof_p1',
    name: 'Environment P1 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_environment_value_pof_p2',
    name: 'Environment P2 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_public_impact_value_pof_p1',
    name: 'Public Impact P1 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_public_impact_value_pof_p2',
    name: 'Public Impact P2 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_direct_cost_value_pof_p1',
    name: 'Direct Cost P1 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_direct_cost_value_pof_p2',
    name: 'Direct Cost P2 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_business_loss_value_pof_p1',
    name: 'Business Loss P1 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_business_loss_value_pof_p2',
    name: 'Business Loss P2 (POF)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_facing_type',
    name: 'Facing Type',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_pad_thickness', name: 'Pad Thickness (<12mm)', isHidden: false, isInput: true },
  {
    key: 'risk_timber_service_time',
    name: 'Timber service time (years)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_cross_section_loss_in_area',
    name: 'Cross-section loss in area (<40%)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_cracking_in_timber_fendering',
    name: 'Cracking in timber fendering',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_safety_value_pof_c', name: 'Safety (C)', isHidden: false, isInput: true },
  { key: 'risk_environment_value_pof_c', name: 'Environment (C)', isHidden: false, isInput: true },
  {
    key: 'risk_public_impact_value_pof_c',
    name: 'Public Impact (C)',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_direct_cost_value_pof_c', name: 'Direct Cost (C)', isHidden: false, isInput: true },
  {
    key: 'risk_business_loss_value_pof_c',
    name: 'Business Loss (C)',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_damage_class', name: 'Damage Class', isHidden: false, isInput: false },
  {
    key: 'risk_unmitigated_she_category',
    name: 'Governing SHE RC',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_unmitigated_financials_category',
    name: 'Governing Financial RC',
    isHidden: false,
    isInput: false,
  },
  {
    key: 'risk_environmental_exposure',
    name: 'Envrionmental Exposure',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_transition_date_1', name: 'Transition Date 1', isHidden: false, isInput: false },
  { key: 'risk_transition_date_2', name: 'Transition Date 2', isHidden: false, isInput: false },
  { key: 'risk_transition_date_3', name: 'Transition Date 3', isHidden: false, isInput: false },
  { key: 'risk_transition_date_4', name: 'Transition Date 4', isHidden: false, isInput: false },
  { key: 'risk_transition_date_5', name: 'Transition Date 5', isHidden: false, isInput: false },
  { key: 'risk_recommendation_damage_type', name: 'Damage Type', isHidden: true, isInput: false },
  { key: 'risk_edd_method', name: 'EDD Method', isHidden: false, isInput: false },
  {
    key: 'risk_recommendation_damage_metric',
    name: 'Damage Metric',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_recommendation_inspection_method',
    name: 'Inspection Method',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_recommendation_damage_class_comment',
    name: 'Damage Class Comment',
    isHidden: true,
    isInput: false,
  },
  {
    key: 'risk_inspection_performed',
    name: 'Inspection performed',
    isHidden: false,
    isInput: false,
  },
  { key: 'risk_years_in_service', name: 'Years in service', isHidden: false, isInput: true },
  {
    key: 'risk_hardness_percentage',
    name: 'Increase in hardness (percentage %)',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_longitudinal_cracking',
    name: 'Longitudinal cracking',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_circumferential_cracking',
    name: 'Circumferential cracking',
    isHidden: false,
    isInput: true,
  },
  { key: 'risk_sagging_fender', name: 'Sagging fender multiplier', isHidden: false, isInput: true },
  {
    key: 'risk_compression_set_fender',
    name: 'Compression set fender multiplier',
    isHidden: false,
    isInput: true,
  },
  {
    key: 'risk_selected_equation',
    name: 'Selected POF Equation',
    isHidden: false,
    isInput: true,
  },
];

export const riskInputKeysObject: Record<string, string> = calculationKeys
  .filter((field) => field.isInput)
  .reduce((accumulator, { name, key }) => {
    accumulator[key] = name;
    return accumulator;
  }, {} as Record<string, string>);

export const riskOutputKeysObject: Record<string, string> = calculationKeys
  .filter((field) => !field.isInput && !field.isHidden)
  .reduce((accumulator, { name, key }) => {
    accumulator[key] = name;
    return accumulator;
  }, {} as Record<string, string>);
